import * as React from "react";

import ExecuteForm from "../../../components/Forms/GovErrand/ExecuteForm/FlowForm";

export default () => {
  return <ExecuteForm />;
};
